import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';

import { NumberField } from 'Shared/form/NumberField';
import withFormikFields from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from '../CommonPatientFieldWrapper';

const HeightField = ({ fieldValues: { height } }) => {
    return (
        <CommonPatientFieldWrapper fieldName="height">
            {(commonProps) => (
                <Col md={3}>
                    <NumberField
                        {...commonProps}
                        placeholder="Height in Inches"
                        label={
                            <>
                                <span>Height (Inches)</span>
                                {height > 0 && <span className="float-right">{(height * 2.54).toFixed(1)} cm</span>}
                            </>
                        }
                    />
                </Col>
            )}
        </CommonPatientFieldWrapper>
    );
};

HeightField.propTypes = {
    fieldValues: PropTypes.shape({
        height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }).isRequired,
};

export default withFormikFields({ WrappedComponent: HeightField, fieldNames: ['height'] });
